import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldAlert } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function UnknownRoutePage() {
  return <main className="min-h-screen flex items-center justify-center p-6 bg-slate-50" data-testid="unknown-route-page">
    <section className="max-w-md space-y-5 text-center" role="alert" data-testid="unknown-route-denied">
      <ShieldAlert className="mx-auto h-10 w-10 text-teal-700" />
      <h1 className="text-2xl font-semibold">Page unavailable</h1>
      <p className="text-sm text-slate-600">This address does not match an available page.</p>
      <Button asChild variant="outline"><Link to="/dashboard" data-testid="unknown-route-back"><ArrowLeft size={16} />Back to workspace</Link></Button>
    </section>
  </main>;
}